import { createContext } from 'react';
import { SovosEnvironment } from '../types';
const PlatformContext = createContext({
    environment: SovosEnvironment.dev,
});
export default PlatformContext;
